import React from "react"
import { FieldPath, FieldValues, FormProvider } from "react-hook-form"

const Form = FormProvider

type FormFieldContextValue<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName
}

type FormItemContextValue = {
  id: string
}

const FormItemContext = React.createContext<FormItemContextValue>({} as FormItemContextValue)
const FormFieldContext = React.createContext<FormFieldContextValue>({} as FormFieldContextValue)

export {Form, FormItemContext, FormFieldContext}
